
import { ConferenceListItem } from "@gsx/common/src/types/http/dashboard/conference";
import { Container } from "inversify";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { AuthStore } from "../../../../common/src/stores/AuthStore";
import { UserEditFavoriteStore } from "../../stores/user/UserEditFavoriteStore";
import CalendarEvent from "./CalendarEvent.vue";

@Component({
    components: {
        CalendarEvent,
    },
})
export default class FavoritedCalendarEvent extends Vue {
    @Prop() conferenceListItem!: ConferenceListItem;
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    userEditFavoriteStore: UserEditFavoriteStore = this.container.get(UserEditFavoriteStore);

    removeEvent() {
        const indexOf =
            this.authStore.user!.favorites!.conferenceIds?.indexOf(
                this.conferenceListItem.conferenceid,
            ) || -1;
        if (indexOf >= 0) {
            this.authStore.user?.favorites?.conferenceIds?.splice(indexOf, 1);
        }
        this.userEditFavoriteStore.removeConference(this.conferenceListItem.conferenceid);
    }
}
